import React, { Component } from "react"
import PropTypes from "prop-types"

class Add extends Component {
	state = {
		isAdded: localStorage.getItem("enquiry-product") && localStorage.getItem("enquiry-product").includes(this.props.id),
	};
	addToStorage = () => {
		this.setState({
			isAdded: !this.state.isAdded,
		})
		this.props.addToStorage()
	}
	render() {
		return (
            <div
                onClick={this.addToStorage}
                className="btn btn--tooltip btn--enquiry"
            >
                {this.state.isAdded
                ? <svg><use xlinkHref="#remove-icon" /></svg>
                : <svg><use xlinkHref="#plus-icon" /></svg>}

                {this.state.isAdded
                    ? <div className="btn__tooltip">Remove from enquiry</div>
                    : <div className="btn__tooltip">Add to enquiry</div>}
            </div>
		)
	}
}
Add.propTypes = {
	id: PropTypes.string.isRequired,
	addToStorage: PropTypes.func.isRequired,
}
export default Add